import React, { Component, Fragment } from "react";
import NewLine from "../../../d3Components/NewLineChart/NewLine/newLine";
import ContainerDimensions from "react-container-dimensions";
import TableHolder from "../../../PortfolioDashboard/navigationPages/performance/portfolioGrowth/section2/tableHolder";
// import BoxGrid from "../../../common/boxGrid";
import BoxGrid from "../../../PortfolioDashboard/navigationPages/statistics/RiskStatistic/section2/boxGrid/boxGrid";
import Spinner from "../../../PortfolioDashboard/navigationPages/Datatable/spinner/spinner";
import Legend from "../../../d3Components/legend";

class LineChartHolder extends Component {
  state = {
    Line_chart_data: [],
  };

  componentDidMount() {
    let BenchmarkData = this.props.getBacktest.getBenchmarkVami.map((d) => {
      return [new Date(d.dt), d.vami * 1];
    });
    let PortfolioData = this.props.getBacktest.getPortfolioVami.map((d) => {
      return [new Date(d.dt), d.vami * 1];
    });

    let Line_chart_data = [
      {
        data: PortfolioData,
        label: "Portfolio",
      },
      {
        data: BenchmarkData,
        label: "Benchmark",
      },
    ];
    this.setState({
      Line_chart_data,
    });
  }
  render() {
    const { Line_chart_data } = this.state;
    const { getPerfHistMetrics, getRiskStatistics } = this.props;
    return (
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <h4 className="text-uppercase bold">Portfolio growth </h4>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Legend
              height={30}
              width={500}
              legend1="Portfolio"
              legend2="Benchmark"
              // legend1={props.newBenchmarkName ? "IQCIO portfolio" : null}
              // legend2={
              //   props.newBenchmarkName ? "Original portfolio" : typeName
              // }
              // legend3={props.newBenchmarkName ? props.newBenchmarkName : null}
            />
          </div>
          <ContainerDimensions>
            {({ width }) => (
              <Fragment>
                {width > 0 ? (
                  <NewLine
                    chartId={"retire_lineChart_01"}
                    data={Line_chart_data}
                    height={300}
                    width={width}
                  />
                ) : null}
              </Fragment>
            )}
          </ContainerDimensions>
          {getPerfHistMetrics.length > 0 ? (
            <TableHolder HistMetricsLive={getPerfHistMetrics} />
          ) : null}
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          {getRiskStatistics.length > 0 ? (
            <Fragment>
              <BoxGrid benchmark_data={getRiskStatistics} />
            </Fragment>
          ) : (
            <Spinner />
          )}
        </div>
      </div>
    );
  }
}

export default LineChartHolder;



// WEBPACK FOOTER //
// ./src/components/pages/Retire/solution/lineChartHolder.jsx